import React from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { openCalendlyPopup } from '../utils/calendly';
export function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const {
    t
  } = useLanguage();
  const footerLinks = {
    product: [{
      label: t('footer.features'),
      href: '/#features',
      isAnchor: true
    }],
    company: [{
      label: t('footer.about'),
      href: '/about',
      isAnchor: false
    }, {
      label: t('footer.contact'),
      href: '#',
      isCalendly: true
    }, {
      label: t('footer.blog'),
      href: '/blog',
      isAnchor: false
    }],
    legal: [{
      label: t('footer.privacy'),
      href: '/datenschutz',
      isAnchor: false
    }, {
      label: t('footer.imprint'),
      href: '/impressum',
      isAnchor: false
    }]
  };
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (isHomePage && href.startsWith('/#')) {
      e.preventDefault();
      const id = href.substring(2);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const handleCalendlyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openCalendlyPopup();
  };
  return <footer className="bg-[#0a0e1a] border-t border-white/5" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-117">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12" data-id="element-118">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-119">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-120">
              <span className="text-xl font-bold text-white" data-id="element-121">CRM</span>
              <span className="text-xl font-bold text-[#ff6b35]" data-id="element-122">Kraft</span>
            </Link>
            <p className="text-gray-400 text-sm mb-6" data-id="element-123">{t('footer.tagline')}</p>
            <div className="flex gap-4" data-id="element-124">
              <a href="https://www.instagram.com/kraftjustus/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-125">
                <InstagramIcon className="w-5 h-5" data-id="element-126" />
              </a>
              <a href="https://www.facebook.com/kraftjustus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-127">
                <FacebookIcon className="w-5 h-5" data-id="element-128" />
              </a>
              <a href="https://www.linkedin.com/in/justus-kraft/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-129">
                <LinkedinIcon className="w-5 h-5" data-id="element-130" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div data-id="element-131">
            <h4 className="text-white font-semibold mb-4" data-id="element-132">
              {t('footer.product')}
            </h4>
            <ul className="space-y-3" data-id="element-133">
              {footerLinks.product.map(link => <li key={link.label} data-id="element-134">
                  {link.isAnchor ? <a href={link.href} onClick={e => handleAnchorClick(e, link.href)} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-135">
                      {link.label}
                    </a> : <Link to={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-136">
                      {link.label}
                    </Link>}
                </li>)}
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-137">
            <h4 className="text-white font-semibold mb-4" data-id="element-138">
              {t('footer.company')}
            </h4>
            <ul className="space-y-3" data-id="element-139">
              {footerLinks.company.map(link => <li key={link.label} data-id="element-140">
                  {link.isCalendly ? <a href={link.href} onClick={handleCalendlyClick} className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer" data-id="element-141">
                      {link.label}
                    </a> : link.isAnchor ? <a href={link.href} onClick={e => handleAnchorClick(e, link.href)} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-142">
                      {link.label}
                    </a> : <Link to={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-143">
                      {link.label}
                    </Link>}
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-144">
            <h4 className="text-white font-semibold mb-4" data-id="element-145">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-3" data-id="element-146">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-147">
                  <Link to={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-148">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 text-center" data-id="element-149">
          <p className="text-gray-500 text-sm" data-id="element-150">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>;
}